import React, { FC } from 'react';

const RequiredMarker: FC<{ required: boolean }> = ({ required }) => {
    if (required) {
        return (
            <span style={{ color: 'red' }}>* </span>
        );
    }
    return null;
}

type Props = {
    htmlFor: string;
    required?: boolean;
    className?: string;
    requireMarkerDirection?: 'left' | 'right';
    style?: {}
}

const Label: FC<Props> = ({ htmlFor, children, required = false, className, requireMarkerDirection = "left", style = {}}) => {
    return (
        <label htmlFor={htmlFor} className={className} style={style}>
            {requireMarkerDirection === "right" ?
                <>
                    {children} < RequiredMarker required={required} />
                </> :
                <>
                    < RequiredMarker required={required} />{children}
                </>}
        </label>
    );
};

export default Label;
